import {JointUserClient as _JointUserClient} from '../../../shared-models/public/joint-user-client';

export class JointUserClient extends _JointUserClient{
    
}

export namespace JointUserClient{
    export import RestTypes=_JointUserClient.RestTypes;
}
